import { module } from "angular";
import { ExtendedSearchDetailsComponent } from "./ExtendedSearchDetailsComponent";

module("mmGui").component("irExtendedSearchDetails", new ExtendedSearchDetailsComponent());
